<vdr-affixed-input [suffix]="suffix" [prefix]="prefix">
  <input type="text" [readonly]="readonly" [formControl]="formControl" />
</vdr-affixed-input>
